import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { changeRemoteExtractRefreshExpectedDuration } from '../../../actions/spaces/ChangeRemoteExtractRefreshExpectedDurationAction';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { currentUserIsOwnerOrAdmin } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ChangeRemoteExtractRefreshExpectedDurationEntityAction:
  IEntityAction<IRemoteRefreshScheduleInfo, any> = {
  name: EntityActionNames.TasksEditExpectedDuration,
  translateName: Messages.editRemoteRefreshExpectedDuration_action,
  isVisible: () => {
    return FeatureFlags.bridgeSendWarningForExtractRefresh;
  },
  isClickable: isClickable,
  createReduxAction: (items: IRemoteRefreshScheduleInfo[]) => changeRemoteExtractRefreshExpectedDuration(items[0])
};

function isClickable(
  availableActions: any,
  schedules: IRemoteRefreshScheduleInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsOwnerOrAdmin(state, spaceItem);
}
